import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    role: '',
    userName: '',
    userId: null,
    keepAlive: [],
    adminImageList: [],
  },
  mutations: {
    setRole(state, payload) {
      state.role = payload.role;
    },
    setUserName(state, payload) {
      state.userName = payload.userName;
    },
    setUserId(state, payload) {
      state.userId = payload.userId;
    },
    setKeepAlive: (state, keepAlive) => {
      state.keepAlive = keepAlive;
    },
    addKeepAlive: (state, keepAlive) => {
      state.keepAlive = [...state.keepAlive, keepAlive];
    },
    // 为解决同一图片存在不同标注任务的问题，imageList元素变为object { imageId: 1, taskId: 1 }
    setAdminImageList: (state, payload) => {
      state.adminImageList = payload.imageList;
    },
  },
  getters: {
    keepAlive: state => state.keepAlive,
  },
  actions: {},
  modules: {},
});
